import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import './PageBody.less';

export default class PageBody extends PureComponent {
    static propTypes = {
        children: PropTypes.node.isRequired,
        withPadding: PropTypes.bool
    };

    static defaultProps = {
        withPadding: true
    };

    render() {
        const { children, withPadding } = this.props;
        const wrapperClasses = [
            'PageBody',
            withPadding ? 'PageBody--with-padding' : ''
        ];

        return (
            <div className={wrapperClasses.join(' ')}>
                {children}
            </div>
        );
    }
}
